import { Component } from '@angular/core';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Platform } from '@ionic/angular';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss'],
})
export class ProfileDetailComponent {
  constructor(private auth: AuthService,
    public handler: HandlerService,
      public platform: Platform,
      public service: ApiService,
    private bottomSheet: MatBottomSheet,
    ) { }
 id;
  email : boolean = true;numb;phone;
  detail; pass; hide; userlocation;
  loginmob: boolean = true; numCd = '+91'; firstName;mob;
  loader:boolean = false;emailId;
details;
  ionViewWillEnter(){
    this.id=localStorage.getItem('currentUserId');
 this.getUser();
  }

  checkMob(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    this.numb = event.target.value;
  }

  changeInput() {
    this.loginmob = !this.loginmob;
    this.detail = "";
  }

  getUser(){
    this.loader = true;
    this.service.getUserDetailsById(this.id).subscribe((res:any)=>{
      this.details=res;
      this.loader = false;
      this.firstName = this.details.firstName;
      this.mob = this.details.contactNbrMob.slice(3);
      this.emailId = this.details.emailId;  
     if(this.mob){
       localStorage.setItem('mobile' , this.mob)
     }
    })
  }
  



  updateUser(){
    this.loader = true;
  this.details.firstName = this.firstName;
  this.details.contactNbrMob =  this.mob  ;
  this.details.emailId =  this.emailId;
  this.service.updateUser(localStorage.getItem('currentUserId'),this.details).subscribe(res=>{
    this.getUser()
    this.handler.res('Profile Details Updated Successfully')

  },err=>{
    this.handler.err(err)
    this.loader=false;
  }) 
  }

}
